import { render, staticRenderFns } from "./ShopLook.vue?vue&type=template&id=0116fe5a&"
import script from "./ShopLook.vue?vue&type=script&lang=js&"
export * from "./ShopLook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports